/**
 * Fetch page content by ID.
 *
 * @param {number} pageId - The ID of the page to fetch.
 * @param {function} useQuery - The query hook to use for fetching.
 * @returns {object} The query result.
 */
export const pageContent = (pageId, useQuery, options) => useQuery(
	["page", pageId],
	() => fetch( `${process.env.REACT_APP_API_URL}/wp-json/wp/v2/pages/${pageId}`).then(res => res.json()),
	{
		staleTime: 600000,
		...options
	}
);
